const links = [
  { name: 'DOT COM', link: '/dot/com' },
  { name: 'NOT COM', link: '/dot/not' },
  { name: 'DOT APP', link: '/dot/app' },
  { name: 'TAILORED', link: '/dot/tailored' },
];

export default links;